module.exports = __webpack_public_path__ + "static/media/todos-consultation.33597ea2.svg";